import React from 'react';
import { PageHero } from '../components/ui/PageHero';
import { Reveal } from '../components/ui/Reveal';
import { SectionLabel } from '../components/ui/SectionLabel';
import { SplitText } from '../components/ui/SplitText';
import { TestimonialsSection } from '../components/home/TestimonialsSection';
import { CtaBanner } from '../components/CtaBanner';
import { images } from '../data/images';
import { timeline, values, credentials } from '../data/about';
export function About() {
  return <>
      <PageHero label="À propos" title="Vingt ans d’achats, vus de l’intérieur." description="Avant d’être consultante, j’ai été acheteuse, responsable de catégories puis directrice achats et supply chain. Je connais vos contraintes parce que je les ai vécues." image={images.meeting} data-id="element-423" data-mp="377nn0dk3lx25" />

      <section className="bg-paper py-24 lg:py-32" data-id="element-424" data-mp="1gtenrfvys5va">
        <div className="mx-auto grid max-w-[1440px] gap-14 px-5 sm:px-8 lg:grid-cols-12 lg:gap-20" data-id="element-425" data-mp="1ltszb7wrxxy2">
          <Reveal className="lg:col-span-5" data-id="element-426" data-mp="1uhigjk3kou8a">
            <img src={images.portrait} alt="La fondatrice de L Procure Consulting" className="aspect-[4/5] w-full rounded-[28px] object-cover object-top" data-id="element-427" data-mp="1uibm4hqspdou" />
          </Reveal>
          <div className="lg:col-span-7" data-id="element-428" data-mp="23g3tmzq9zh1o">
            <SectionLabel data-id="element-429" data-mp="1yj3uz9vr9gkl">Qui suis-je ?</SectionLabel>
            <h2 className="mt-6 text-[clamp(1.8rem,3.4vw,2.75rem)] font-medium leading-[1.12] tracking-[-0.02em]" data-id="element-430" data-mp="1ylq59ha16a6i">
              <SplitText text="Une consultante opérationnelle, qui s’engage sur des résultats." data-id="element-431" data-mp="28ht5ghlbnyqt" />
            </h2>
            <Reveal delay={0.1} data-id="element-432" data-mp="2m9hegc09y73k">
              <div className="mt-8 space-y-5 text-lg leading-relaxed text-muted" data-id="element-433" data-mp="2m8g4kauzvqnf">
                <p data-id="element-434" data-mp="2i8fgdyi3g136">
                  J’ai commencé ma carrière sur le terrain, dans les ateliers et les entrepôts, à négocier avec des
                  fournisseurs de composants. Puis j’ai dirigé des équipes achats et supply chain, conduit des
                  transformations et déployé des ERP.
                </p>
                <p data-id="element-435" data-mp="1ow7mzs46fjno">
                  En 2020, j’ai créé L Procure Consulting avec une conviction : les PME et ETI méritent la même
                  expertise achats que les grands groupes, sans la lourdeur des grands cabinets.
                </p>
                <p data-id="element-436" data-mp="22lrlglqq5ur6">
                  Aujourd’hui, j’interviens en conseil ou en management de transition pour réduire les coûts,
                  sécuriser les approvisionnements et faire grandir les équipes.
                </p>
              </div>
              <ul className="mt-10 grid gap-x-8 gap-y-4 border-t border-ink/15 pt-8 sm:grid-cols-2" data-id="element-437" data-mp="2cinuqtog6kws">
                {credentials.map(c => <li key={c} className="flex gap-3 text-[15px] leading-relaxed" data-id="element-438" data-mp="2lknazjrn1kyo">
                    <span className="mt-2.5 h-1.5 w-1.5 shrink-0 rounded-full bg-brass" aria-hidden="true" data-id="element-439" data-mp="2lij7v41kcpzg" />
                    {c}
                  </li>)}
              </ul>
            </Reveal>
          </div>
        </div>
      </section>

      <section className="bg-ink py-24 text-white lg:py-32" data-id="element-440" data-mp="jo50am0qp72g">
        <div className="mx-auto max-w-[1440px] px-5 sm:px-8" data-id="element-441" data-mp="ewwqvpzetlpa">
          <SectionLabel tone="dark" data-id="element-442" data-mp="euk0qpji0515">Parcours</SectionLabel>
          <h2 className="mt-6 max-w-2xl text-[clamp(2rem,4vw,3.25rem)] font-medium leading-[1.08] tracking-[-0.03em]" data-id="element-443" data-mp="9ylhthgxvf84">
            <SplitText text="Du terrain à la direction achats." data-id="element-444" data-mp="501txbisbtd4" />
          </h2>
          <ol className="mt-16 grid gap-10 md:grid-cols-2 lg:grid-cols-5 lg:gap-6" data-id="element-445" data-mp="12l67mdhrnj9k">
            {timeline.map((t, i) => <li key={t.period} data-id="element-446" data-mp="xno0msnb7e47" data-mpi={i}>
                <Reveal delay={0.06 * i} data-id="element-447" data-mp="so1hy3opp5o0">
                  <div className="border-t border-white/20 pt-6" data-id="element-448" data-mp="sn04jsk84734">
                    <p className="text-sm text-brass" data-id="element-449" data-mp="omq0ilfzrqqw">{t.period}</p>
                    <h3 className="mt-2 text-xl font-medium" data-id="element-450" data-mp="ooiylccjh2na">{t.title}</h3>
                    <p className="mt-3 text-[15px] leading-relaxed text-white/65" data-id="element-451" data-mp="3dftyhxzxk919">{t.text}</p>
                  </div>
                </Reveal>
              </li>)}
          </ol>
        </div>
      </section>

      <section className="bg-paper py-24 lg:py-32" data-id="element-452" data-mp="112o0v01e6ck6">
        <div className="mx-auto grid max-w-[1440px] gap-14 px-5 sm:px-8 lg:grid-cols-12" data-id="element-453" data-mp="15uz3ianiocgf">
          <div className="lg:col-span-4" data-id="element-454" data-mp="r6bb2d8ywiup">
            <SectionLabel data-id="element-455" data-mp="r7dz8dewo76x">Valeurs</SectionLabel>
            <h2 className="mt-6 text-[clamp(2rem,4vw,3.25rem)] font-medium leading-[1.08] tracking-[-0.03em]" data-id="element-456" data-mp="w4miyifpcjaa">
              <SplitText text="Ce qui guide chaque mission." data-id="element-457" data-mp="1ju75tcez80ou" />
            </h2>
          </div>
          <dl className="grid gap-x-12 gap-y-12 sm:grid-cols-2 lg:col-span-8" data-id="element-458" data-mp="1ou3a7crl5u4x">
            {values.map((v, i) => <Reveal key={v.title} delay={0.06 * i} data-id="element-459" data-mp="1asqwl7zwe4m7" data-mpi={i}>
                <dt className="text-2xl font-medium tracking-tight" data-id="element-460" data-mp="1evdqrfk1k1mk">{v.title}</dt>
                <dd className="mt-3 leading-relaxed text-muted" data-id="element-461" data-mp="1exgpqp36953f">{v.text}</dd>
              </Reveal>)}
          </dl>
        </div>
      </section>

      <TestimonialsSection data-id="element-462" data-mp="3h9ycdt3qljm" />
      <CtaBanner data-id="element-463" data-mp="3hjqo81md4sh" />
    </>;
}